import { CLINIC } from "@/constants/clinic";

export default function DoctorIntro() {
    return (
        <section
            className="relative"
            style={{
                background:
                    "radial-gradient(70% 90% at 10% 50%, hsl(var(--brand-gold-soft) / 0.45) 0%, transparent 55%), hsl(var(--bg-chalk))",
            }}
        >
            <div className="ihx-container py-20 lg:py-28 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
                <div className="lg:col-span-5 order-2 lg:order-1">
                    <div className="relative max-w-[460px] mx-auto lg:mx-0">
                        <div className="relative aspect-[4/5] overflow-hidden rounded-[28px] bg-[hsl(var(--bg-stone))]">
                            <img
                                src={CLINIC.doctor.photoPortrait}
                                alt={`${CLINIC.doctor.fullName}`}
                                className="w-full h-full object-cover object-center"
                                loading="lazy"
                            />
                        </div>
                        {/* floating quote pill */}
                        <div className="ihx-glass-card absolute -right-4 sm:-right-8 -bottom-6 px-5 py-3 max-w-[280px]">
                            <p className="font-serif italic text-[14.5px] leading-[1.45] text-[hsl(var(--brand-ink-deep))]">
                                “The smallest changes, executed consistently, produce the largest shifts.”
                            </p>
                        </div>
                    </div>
                </div>

                <div className="lg:col-span-7 order-1 lg:order-2">
                    <span className="ihx-eyebrow">Meet the physician</span>
                    <h2 className="ihx-h-section mt-5">
                        Dr. Ishani Hanspal — where clinical rigour meets <span className="ihx-italic">lived empathy.</span>
                    </h2>
                    <p className="ihx-lead mt-6 max-w-2xl">
                        Trained in internal medicine and board-certified in lifestyle
                        medicine (<abbr title="International Board of Lifestyle Medicine">IBLM</abbr>),
                        Dr. Hanspal practises a quieter, deeper kind of care — one
                        that listens longer, tests more carefully, and prescribes the
                        smallest changes that produce the largest shifts.
                    </p>

                    <ul className="mt-9 grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-4 text-[14.5px] text-[hsl(var(--ink-soft))]">
                        {[
                            "MBBS — Foundational clinical medicine",
                            "MD — Internal Medicine",
                            "IBLM Diplomate — Lifestyle Medicine",
                            "Cardio-metabolic & PCOS reversal focus",
                            "Member, American College of Lifestyle Medicine",
                            "Author & speaker — preventive cardiology",
                        ].map((c) => (
                            <li key={c} className="flex items-start gap-3">
                                <span
                                    aria-hidden
                                    className="mt-[10px] inline-block w-[6px] h-[6px] rounded-full bg-[hsl(var(--brand-gold))]"
                                />
                                <span>{c}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    );
}
